import { createFileRoute, Outlet } from "@tanstack/react-router";

type RegisterSearch = Record<string, unknown> & {
  signup_source?: string;
};

export const Route = createFileRoute("/(auth)/register")({
  validateSearch: (search: Record<string, unknown>): RegisterSearch => {
    const raw = search.signup_source;
    const cleaned =
      typeof raw === "string" ? raw.trim().slice(0, 256) : undefined;

    return {
      ...search,
      signup_source: cleaned || undefined,
    };
  },
  component: RegisterLayout,
});

function RegisterLayout() {
  return <Outlet />;
}